import { useState, useEffect } from 'react'

import ClimaPlanilha from './Clima_DadosEmissoes_Abas/ClimaPlanilha'
import ClimaCombustaoEstacionaria from './Clima_DadosEmissoes_Abas/ClimaCombustaoEstacionaria'
import ClimaCombustaoMovel from './Clima_DadosEmissoes_Abas/ClimaCombustaoMovel'
import ClimaCombustaoMovel2 from './Clima_DadosEmissoes_Abas/ClimaCombustaoMovel2'
import ClimaEnergiaEletricaLocalizacaoSIN from './Clima_DadosEmissoes_Abas/ClimaEnergiaEletricaLocalizacaoSIN'
import EnergiaEletricaCompra from './Clima_DadosEmissoes_Abas/ClimaEnergiaEletricaCompra'

const DadosEmissoes = (props) => {

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    var formulario_id = props.formulario_id

    var [secao, setSecao] = useState('')
    

    return (


        <div>

            
                    <div className="row">


                            <div className="col-md-12">
                                
                                <div class="form-group" >
                                    <label className="control-label">
                                        
                                            Seção:
                                        
                                        
                                    </label>
                                    <select className="form-control" value={secao} onChange={event => setSecao(event.target.value)} >
                                        <option value="">[Selecione]</option>
                                        <option value="planilha">Planilha</option>
                                        <option value="combustaoEstacionaria">Combustão Estacionária</option>
                                        <option value="combustaoMovel">Combustão Móvel</option>
                                        <option value="combustaoMovel2">Combustão Móvel 2</option>
                                        <option value="energiaEletricaLocalizacaoSIN">Energia Elétrica Localização SIN</option>
                                        <option value="energiaEletricaCompra">Energia Elétrica Compra</option>
                                        
                                        
                                    </select>
                                        

                                </div>

                            </div>
                            <div className="col-md-12">


                                {
                                    secao == 'planilha' && (

                                        <>
                                        
                                            <ClimaPlanilha adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} />
                                        
                                        </>

                                    )
                                }
                                {

                                    secao == 'combustaoEstacionaria' && (

                                        <>
                                        
                                            <ClimaCombustaoEstacionaria adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} />
                                        
                                        </>

                                    )
                                }

                                 {

                                    secao == 'combustaoMovel' && (

                                        <>
                                        
                                            <ClimaCombustaoMovel adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} />
                                        
                                        </>

                                    )
                                }



                                 {   
                                 
                                    secao == 'combustaoMovel2' && (

                                        <>
                                        
                                            <ClimaCombustaoMovel2 adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} />
                                        
                                        </>

                                    )
                                }



                                 {   
                                 
                                    secao == 'energiaEletricaLocalizacaoSIN' && (

                                        <>
                                        
                                            <ClimaEnergiaEletricaLocalizacaoSIN adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} />
                                        
                                        </>

                                    )
                                }



                                 {   
                                 
                                    secao == 'energiaEletricaCompra' && (

                                        <>
                                        
                                            <EnergiaEletricaCompra adesao_institucional_id={adesao_institucional_id} ano={ano} formulario_id={formulario_id} />
                                        
                                        </>

                                    )
                                }




                            </div>


                    </div>

                    

            


            

        </div>

    )

}

export default DadosEmissoes